module.exports = __webpack_public_path__ + "newprotal/img/pbs4.a8b146a0.png";